import React from "react";
import { motion } from "framer-motion";

const list = {
  visible: {
    opacity: 1,
    transition: {
      delay: 2,
      when: "beforeChildren",
      staggerChildren: 0.4,
    },
  },
  hidden: {
    opacity: 0,
    transition: {
      when: "afterChildren",
    },
  },
};

const item = {
  visible: { opacity: 1 },
  hidden: { opacity: 0 },
};

export default function CenterDisc({ lessons, isShowing }) {
  const largestRadius = 5.6;
  const step = largestRadius / lessons.length;

  return (
    <motion.g
      animate={isShowing ? "visible" : "hidden"}
      initial="hidden"
      variants={list}
    >
      {lessons.map((c, i) => {
        return (
          <motion.circle
            key={`disc-${i}`}
            variants={item}
            cx="81.37"
            cy="120.75"
            r={largestRadius - i * step}
            fill={c.colour}
          />
        );
      })}
    </motion.g>
  );
}
